// library imports
import { useState } from "react";
// hook imports
import useFetch from "./useFetch";

export default function useHasTnbSelected() {
  const [fetchWrapper] = useFetch();

  // loading state
  const [getHasTnbSelectedLoading, setGetHasTnbSelectedLoading] =
    useState(false);

  // this state is to check whether the site has Tnb
  const [hasTnbSelected, setHasTnbSelected] = useState(false);

  /* API to check whether site has Tnb that is selected and not deleted */
  function getHasTnbSelected({ siteSelected }) {
    setGetHasTnbSelectedLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getHasTnbSelected",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
      },
      onSuccess: (response) => {
        setGetHasTnbSelectedLoading(false);
        setHasTnbSelected(response.data);
      },
    });
  }

  return [hasTnbSelected, getHasTnbSelected, getHasTnbSelectedLoading];
}
